<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header>
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Collection')"
            variant="primary"
            :to="{ name: 'collections-create'}"
          >
            + Buat Koleksi
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="collections.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Nama -->
        <template #cell(title)="data">
          <b-media
            vertical-align="center"
          >
            <template #aside>
              <b-img
                rounded
                width="50"
                :src="linkStaging(data.item.image_url, 50, 50)"
                alt=""
              />
            </template>
            <span class="font-weight-bold d-block">
              {{ data.item.title }}
            </span>
            <small
              v-if="data.item.category"
              class="text-muted">{{ data.item.category.name }}</small>
          </b-media>
        </template>

        <!-- Column: Position -->
        <template #cell(position)="data">
          {{ data.item.position ? data.item.position : '-' }}
        </template>

        <!-- Column: Type -->
        <template #cell(type)="data">
          {{ data.item.type ? data.item.type : '-' }}
        </template>

        <!-- Column: Produk -->
        <template #cell(products)="data">
          {{ `${data.item.collectionProducts.length} Produk` }}
        </template>

        <!-- Column: Position -->
        <template #cell(isActive)="data">
          <b-badge :variant="data.item.is_active ? 'light-success' : ''">
            {{ data.item.is_active ? 'Aktif' : 'Tidak Aktif' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'Collection')"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="collections.meta"
          action="collections/getCollections"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Collection')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Collection ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BTable,
  BImg,
  BSpinner,
  BMedia,
  BBadge,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BButton,
    BTable,
    BImg,
    BSpinner,
    BMedia,
    BBadge,
    Pagination,
    TableHeader,
    TableAction,
  },
  data() {
    return {
      tableFields: [
        { key: 'title', label: 'Judul' },
        { key: 'type', label: 'Tipe' },
        { key: 'products', label: 'Produk' },
        { key: 'position', label: 'Posisi' },
        { key: 'isActive', label: 'Status' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      deletedData: '',
      isDeleting: false,
    }
  },
  computed: {
    ...mapState('collections', ['collections', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'collections-edit|id:id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getCollections(this.query)
  },
  methods: {
    ...mapActions('collections', ['getCollections', 'deleteCollection']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteCollection({ collectionId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
      await this.getCollections()
    },
  },
}
</script>
